<template>
    <section-con :main="vm.main" :sub="vm.sub">
        <div class="img-box">
            <img-swiper :list="vm.list" :isNotAuto="isNotAuto" :isOnly="isOnly"></img-swiper>
        </div>
    </section-con>
</template>
<script>
import imgSwiper from './img-swiper'
export default {
    props: {
        vm: {
            type: Object,
            default: () => {}
        },
        isNotAuto: {
            type: Boolean,
            default: false
        },
        isOnly: {
            type: Boolean,
            default: true
        }
    },
    components: { imgSwiper }
}
</script>